import React, { useEffect, useState } from "react";
import { getTasks } from "../services/api";
import AddTaskForm from "../components/AddTaskForm";
import TaskList from "../components/TaskList";
import AIMessageBox from "../components/AIMessageBox";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import useAuth from "../hooks/useAuth";

export default function Dashboard() {
  useAuth();
  const [tasks, setTasks] = useState([]);
  const token = localStorage.getItem("token");

  const fetchTasks = async () => {
    try {
      const res = await getTasks(token);
      setTasks(res.data || []);
    } catch (err) {
      console.error("Error fetching tasks:", err);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex flex-col">
      <Navbar />
      <div className="max-w-6xl mx-auto p-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">Welcome to Cognify</h1>
          <p className="text-gray-600">Your AI-powered productivity companion</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 space-y-6">
            <AddTaskForm onTaskAdded={fetchTasks} />
            <TaskList tasks={tasks} onTaskUpdated={fetchTasks} />
          </div>
          <div className="space-y-6">
            <AIMessageBox />
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="font-bold text-lg mb-3 text-gray-800">Quick Stats</h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Total Tasks:</span>
                  <span className="font-bold text-blue-600">{tasks.length}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Completed:</span>
                  <span className="font-bold text-green-600">
                    {tasks.filter(t => t.is_completed).length}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Pending:</span>
                  <span className="font-bold text-orange-600">
                    {tasks.filter(t => !t.is_completed).length}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}